import { useCallback, MouseEvent } from 'react';
import { PostUI, ReactionState } from '../../../../types';

interface UseCardActionsHandlersParams {
    index: number;
    onReaction: (params: { postNumber: number; reactionState: PostUI['reactionState'] }) => void;
    onBookmark?: VoidFunction;
}

export const useCardActionsHandlers = ({
    index,
    onReaction,
    onBookmark,
}: UseCardActionsHandlersParams) => {
    const onLikeClick = useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            e.stopPropagation();
            onReaction({ postNumber: index, reactionState: ReactionState.LIKE });
        },
        [onReaction, index],
    );

    const onBookmarkClick = useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            e.stopPropagation();
            onBookmark?.();
        },
        [onBookmark],
    );

    return { onLikeClick, onBookmarkClick };
};
